import { useTranslation } from 'react-i18next';

import { Button, Modal, Paragraph, Popover } from '@treams/treams-ui';

// Warns that unsaved correction changes are lost; shown on cancel and when
// navigating away mid-correction.
export default function CancelTalentReviewCorrectionModal(props: {
	/** Number of people whose placement differs from the submitted review. */
	changes: number;
	onContinue: () => void;
	onDiscard: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover visible center onDismiss={props.onContinue}>
			<Modal>
				<Modal.Header
					title={t('talentReviews.v2.snapshot.correcting.cancelTitle')}
					onClose={props.onContinue}
				/>
				<Modal.Contents>
					<Paragraph>
						{t('talentReviews.v2.snapshot.correcting.cancelConfirm', { count: props.changes })}
					</Paragraph>
				</Modal.Contents>
				<Modal.Footer>
					<Button
						type="secondary"
						title={t('talentReviews.v2.snapshot.correcting.cancelContinue')}
						onClick={props.onContinue}
					/>
					<Button
						ml={2}
						type="primary"
						title={t('talentReviews.v2.snapshot.correcting.cancel')}
						onClick={props.onDiscard}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
